<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">
        {{ $t('administration.mobile_feature.news.news') }}
      </h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          { text: $t('administration.mobile_feature.news.news'), active: true }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="row">
          <div class="col-sm-8">
            <ts-button
              color="info"
              outline
              @click="$router.push({ name: 'news-create' })"
            >
              {{ $t('add_new') }}
            </ts-button>
          </div>
          <div class="col-sm-4 d-flex justify-content-end">
            <ts-input
              v-model="search"
              :placeholder="
                $t('administration.mobile_feature.news.search_only_title')
              "
              class="mr-2"
            />
            <ts-button
              outline
              v-tooltip="$t('filter')"
              @click.prevent="showFilter"
            >
              <i class="fa fa-filter"></i>
            </ts-button>
          </div>
        </div>
      </ts-card-wrapper>
      <div class="overflow-auto">
        <ts-table :columns="columns" :records="resources" :loading="loading">
          <template v-slot="{ record }">
            <td class="ts-whitespace-no-wrap">
              {{ record.branch ? record.branch.branch_name_en : '' }}
            </td>
            <td class="text-center">
              <img
                v-if="record.feature_image && !record._featureImageError"
                :src="record.feature_image"
                class="news-feature-image news-feature-image--clickable"
                alt="Feature image"
                @error="$set(record, '_featureImageError', true)"
                @click="previewFeatureImage(record)"
              />
              <span v-else class="news-feature-image-placeholder">
                <i class="far fa-image"></i>
              </span>
            </td>
            <td class="ts-whitespace-no-wrap">
              <a href="#" class="news-title-link" @click.prevent="previewNews(record)">
                {{ record.title }}
              </a>
            </td>
            <td class="text-center">{{ record.created_by }}</td>
            <td class="text-center">{{ record.created_date }}</td>
            <td class="text-center">
              <a
                v-if="!record.is_sent"
                href="#"
                v-tooltip="$t('send')"
                class="mr-2 text-primary"
                @click.prevent="sendNotification(record)"
              >
                <i class="far fa-paper-plane"></i>
              </a>
              <a
                href="#"
                v-tooltip="$t('edit')"
                class="mr-2 text-primary"
                @click.prevent="edit(record)"
              >
                <i class="fas fa-edit"></i>
              </a>
              <a
                href="#"
                v-tooltip="$t('delete')"
                class="text-danger"
                @click.prevent="destroyNews(record)"
                :disabled="record._deleting"
              >
                <i class="fas fa-circle-notch spin" v-if="record._deleting"></i>
                <i class="fas fa-trash" v-else></i>
              </a>
            </td>
          </template>
        </ts-table>
      </div>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination v-model="pagination" @navigate="fetchData">
        </ts-pagination>
      </div>
    </ts-card>
    <a-drawer
      :title="$t('filter')"
      placement="right"
      :closable="false"
      :visible="visible"
      @close="() => (visible = false)"
      :zIndex="1020"
      width="300px"
    >
      <ts-loading-banner :loading="waiting_fetch">
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <a-select
                style="width: 257px"
                v-model="branch_id"
                :options="branchs"
                showSearch
                mode="multiple"
                :filterOption="
                  (input, option) =>
                    option.componentOptions.children[0].text
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                "
                :maxTagCount="1"
                :maxTagTextLength="17"
                :placeholder="$t('all')"
              >
              </a-select>
            </div>
          </div>
        </div>
      </ts-loading-banner>
    </a-drawer>
    <a-modal
      v-model="featureImagePreview.visible"
      :footer="null"
      :title="$t('administration.mobile_feature.news.feature_image')"
      centered
      width="720px"
    >
      <div class="news-feature-image-preview">
        <img
          v-if="featureImagePreview.src && !featureImagePreview.error"
          :src="featureImagePreview.src"
          alt="Feature image preview"
          @error="featureImagePreview.error = true"
        />
        <span v-else class="news-feature-image-preview-placeholder">
          <i class="far fa-image"></i>
        </span>
      </div>
    </a-modal>
    <a-modal
      v-model="newsPreview.visible"
      :footer="null"
      :title="newsPreview.record ? newsPreview.record.title : ''"
      centered
      width="900px"
      :zIndex="1024"
    >
      <div v-if="newsPreview.record" class="news-preview">
        <div class="news-preview-meta">
          <span>{{ newsPreview.record.branch ? newsPreview.record.branch.branch_name_en : '' }}</span>
          <span>{{ newsPreview.record.created_date }}</span>
        </div>
        <div v-if="newsPreview.record.feature_image && !newsPreview.imageError" class="news-preview-feature">
          <img
            :src="newsPreview.record.feature_image"
            alt="Feature image"
            @error="newsPreview.imageError = true"
          />
        </div>
        <div v-if="newsPreview.record.content_en" class="news-preview-content" v-html="newsPreview.record.content_en"></div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'

export default {
  name: 'news',
  data () {
    return {
      loading: false,
      visible: false,
      waiting_fetch: false,
      branchs: [],
      featureImagePreview: {
        visible: false,
        src: '',
        error: false
      },
      newsPreview: {
        visible: false,
        record: null,
        imageError: false
      }
    }
  },
  created () {
    this.fetchData()
  },
  computed: {
    ...mapState('news', ['resources', 'pagination']),
    search: {
      get () {
        return this.$store.state.news.search
      },
      set (newValue) {
        this.$store.commit('news/SET_SEARCH', newValue)
        this.$store.commit('news/RESET_CURRENT_PAGE')
      }
    },
    branch_id: {
      get () {
        return this.$store.state.news.branch_id
      },
      set (newValue) {
        this.$store.commit('news/SET_BRANCH_ID', newValue)
      }
    },
    columns () {
      return [
        { name: this.$t('administration.mobile_feature.news.branch') },
        { name: this.$t('administration.mobile_feature.news.feature_image'), style: 'text-align:center; width: 50px;' },
        { name: this.$t('administration.mobile_feature.news.title') },
        {
          name: this.$t('administration.mobile_feature.news.created_by'),
          style: 'text-align:center; width: 9%;'
        },
        {
          name: this.$t('administration.mobile_feature.news.created_at'),
          style: 'text-align:center; width: 9%;'
        },
        {
          name: this.$t('administration.mobile_feature.news.actions'),
          style: 'text-align:center; width: 7%;'
        }
      ]
    }
  },
  methods: {
    fetchData (attributes) {
      this.loading = true
      this.$store
        .dispatch(
          'news/fetch',
          Object.assign(
            {
              branch_id: this.branch_id
            },
            { ...attributes }
          )
        )
        .then(() => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    async getBranch () {
      return this.$store
        .dispatch('user/getBranch', {
          filter: {
            user_branches: true
          }
        })
        .then(response => {
          this.branchs = response.data.map(el => ({
            value: el.branch_id,
            label: el.branch_name_en
          }))
        })
    },
    edit (record) {
      this.$store.commit('news/SET_EDIT_DATA', record)
      this.$router.push({
        name: 'news-edit',
        params: { id: record.news_id }
      })
    },

    async sendNotification (record) {
      if (await this.$confirmModal.danger(this.$t('are_you_sure_to_send'))) {
        record._deleting = true
        this.$store
          .dispatch('news/sendNotification', record.news_id)
          .then(response => {
            this.fetchData()
            this.$toasted.success(response.message)
            record._deleting = false
          })
          .catch(error => {
            this.$toasted.error(error.message)
            record._deleting = false
          })
      }
    },
    async destroyNews (record) {
      if (await this.$confirmModal.danger(this.$t('are_you_sure_to_delete'))) {
        record._deleting = true
        this.$store
          .dispatch('news/destroy', record.news_id)
          .then(response => {
            this.fetchData()
            this.$toasted.success(response.message)
            record._deleting = false
          })
          .catch(error => {
            this.$toasted.error(error.message)
            record._deleting = false
          })
      }
    },
    async showFilter () {
      this.visible = true
      this.waiting_fetch = true
      await this.getBranch()
      this.waiting_fetch = false
    },
    previewFeatureImage (record) {
      this.featureImagePreview = {
        visible: true,
        src: record.feature_image,
        error: false
      }
    },
    previewNews (record) {
      this.newsPreview = {
        visible: true,
        record,
        imageError: false
      }
    }
  },
  watch: {
    search: debounce(function (search) {
      this.fetchData({ search })
    }, 500),
    branch_id: debounce(function (branch_id) {
      this.fetchData({ branch_id })
    }, 500)
  },
  beforeRouteLeave (to, from, next) {
    if (_.isEmpty(to.params) && to.name != 'news-create') {
      this.$store.commit('news/RESET_STATE')
    }
    next()
  }
}
</script>
<style scoped>
.news-feature-image {
  width: 42px;
  height: 30px;
  object-fit: cover;
  border-radius: 4px;
  border: 1px solid #e5e7eb;
}

.news-feature-image--clickable {
  cursor: zoom-in;
}

.news-feature-image-placeholder {
  display: inline-flex;
  width: 42px;
  height: 30px;
  align-items: center;
  justify-content: center;
  color: #9ca3af;
  background: #f3f4f6;
  border: 1px dashed #d1d5db;
  border-radius: 4px;
}

.news-feature-image-preview {
  display: flex;
  min-height: 220px;
  align-items: center;
  justify-content: center;
  background: #f9fafb;
  border-radius: 6px;
}

.news-feature-image-preview img {
  max-width: 100%;
  max-height: 70vh;
  object-fit: contain;
}

.news-feature-image-preview-placeholder {
  display: inline-flex;
  width: 180px;
  height: 120px;
  align-items: center;
  justify-content: center;
  color: #9ca3af;
  background: #f3f4f6;
  border: 1px dashed #d1d5db;
  border-radius: 6px;
  font-size: 32px;
}

.news-title-link {
  color: #1d4ed8;
  font-weight: 600;
}

.news-title-link:hover {
  text-decoration: underline;
}

.news-preview-meta {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
  color: #6b7280;
  font-size: 12px;
}

.news-preview-feature {
  margin-bottom: 16px;
  text-align: center;
}

.news-preview-feature img {
  max-width: 100%;
  max-height: 360px;
  object-fit: contain;
  border-radius: 6px;
}

.news-preview-content {
  max-height: 65vh;
  overflow-y: auto;
}
</style>
